import format from "date-fns/format";
import isDate from "date-fns/isDate";
import parseISO from "date-fns/parseISO";

import { MEDIUM_DATE_FORMAT, LONG_DATE_FORMAT } from "@/services/constants";

export const formatPrice = val =>
  val === 0 || val ? `$${val.toFixed(2)}` : "";

export const formatDollars = val =>
  (val / 100).toLocaleString("en-US", {
    style: "currency",
    currency: "USD"
  });

// the following map matches moment.js, see: https://momentjs.com/
const dateFormatMap = {
  L: MEDIUM_DATE_FORMAT,
  LL: LONG_DATE_FORMAT
};

export const formatDate = (val, formatKey = MEDIUM_DATE_FORMAT) => {
  if (!val) return "";

  let date = val;
  if (!isDate(date)) {
    date = parseISO(date);
    if (isInvalidDate(date)) date = new Date(val);
  }
  return format(date, dateFormatMap[formatKey] || formatKey);
};

export const formatTIN = (val, formatKey) => {
  if (!val) return "";

  let tin = val;
  if (tin.length === 9) {
    if (formatKey === "SSN") {
      tin =
        tin.substring(0, 3) +
        "-" +
        tin.substring(3, 5) +
        "-" +
        tin.substring(5);
    } else if (formatKey === "EIN") {
      tin = tin.substring(0, 2) + "-" + tin.substring(2);
    }
  }
  return tin;
};

const isInvalidDate = date => date instanceof Date && isNaN(date);
